/**
 * API endpoint constants
 */
export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: "/api/user-service/login",
    GOOGLE_LOGIN: "/api/user-service/login/google",
    APPLE_LOGIN: "/api/user-service/signup/apple",
    SIGNUP: "/api/user-service/signup",
    CONTACT_US: "/api/user-service/contact-us",
    RESEND_VERIFICATION: "/api/user-service/resend-verification",
    FORGOT_PASSWORD: "/api/user-service/forgot-password",
    LEGACY_LOGIN: "/auth/login",
    LOGOUT: "/api/user-service/logout",
    ME: "/auth/me",
    SEND_OTP: "/api/sms-service/sms/send-otp",
    VERIFY_OTP: "/api/sms-service/sms/verify-otp",
    UPDATE_USER_PROFILE: "/api/user-service/profile",
  },
  USER: {
    PROFILE: "/api/user-service/profile",
    AVATAR: "/api/user-service/avatar",
    DELETE_ACCOUNT: "/api/user-service/account/delete",
  },
  USERS: {
    BASE: "/users",
    BY_ID: (id: string) => `/users/${id}`,
  },
  PROPERTY: {
    ADD: "/api/property-service/properties",
    UPDATE: "/api/property-service/properties/update",
    DELETE: "/api/property-service/properties/delete",
    LIST: (queryParam: string) => `/api/property-service/properties/list?${queryParam}`,
    DETAILS: (propertyId: string) => `/api/property-service/properties/${propertyId}/details`,
    PRICE_DESCRIPTIONS: "/api/property-service/price-descriptions",
    PROTEST_STATUS: (propertyId: string) =>
      `/api/property-service/properties/${propertyId}/protest-status`,
    PROTEST_APPLICABILITY: (propertyId: string) =>
      `/api/property-service/properties/${propertyId}/protest-applicability`,
    SERVICE_EXPANSION_REQUEST: "/api/property-service/service-expansion-request",
    REAL_ESTATE_AUTOCOMPLETE: "/api/property-service/real-estate/autocomplete",
    REAL_ESTATE_PROPERTY_SEARCH: "/api/property-service/real-estate/property-search",
    REAL_ESTATE_PROPERTY_DETAIL: "/api/property-service/real-estate/property-detail",
    CRIME_SEX_OFFENDERS_LOCATION: "/api/property-service/crime/sex-offenders/location",
    CRIME_SEX_OFFENDERS_RECORDS: "/api/property-service/crime/sex-offenders/records",
    CRIME_INCIDENTS_LOCATION: "/api/property-service/crime/incidents/location",
    CRIME_INCIDENTS_BY_LOCATION: "/api/property-service/crime/incidents/byLocation",
    SERP_SEARCH: "/api/property-service/integrations/serpapi/search",
    PROTEST_SAVE_DOCUMENTS: "/api/property-service/protests/save-documents",
    PAYMENT_CREATE_INTENT: "/api/property-service/payments/create-intent",
    PAYMENT_CREATE_MULTI_INTENT: "/api/property-service/payments/create-multi-intent",
    PAYMENT_UPDATE_STATUS: "/api/property-service/payments/update-status",
    PAYMENT_CHECKOUT_STATUS: (sessionId: string) =>
      `/api/property-service/payments/checkout-status?session_id=${encodeURIComponent(sessionId)}`,
    SUPPORTING_DOCUMENTS: "/api/property-service/supporting-documents",
    SUPPORTING_DOCUMENT_BY_ID: (documentId: string) =>
      `/api/property-service/supporting-documents/${documentId}`,
    USER_ACHIEVEMENT: "/api/property-service/user/achievement",
    PROTEST_EXEMPTIONS_LIST: (search: string) =>
      `/api/property-service/protests-exemptions/list?${search}`,
    HOMESTEAD_EXEMPTION_SIGN: "/api/property-service/documents/homestead-exemption-sign",
    HOMESTEAD_DOCUMENTS: "/api/property-service/homestead-documents",
    SUBSCRIPTIONS_LIST: "/api/property-service/user/subscriptions/list",
    SUBSCRIPTIONS_CANCEL: "/api/property-service/user/subscriptions/cancel",
  },
  CHAT: {
    CONVERSATIONS: "/api/chat-service/conversations",
    AVAILABLE_ADMINS: "/api/chat-service/admins/available",
    SESSIONS: "/api/chat-service/sessions",
    MESSAGES: "/api/chat-service/messages",
    CONVERSATION_MESSAGES: (sessionId: string) =>
      `/api/chat-service/conversations/${sessionId}/messages?page=1&page_size=20`,
  },
  COUPON: {
    APPLY: "/api/coupon-service/coupons/apply",
  },
  NOTIFICATION: {
    BASE: "/api/notification-service",
    LIST: (page: number, pageSize: number, type: string) =>
      `/api/notification-service/notifications?page=${page}&page_size=${pageSize}&type=${type}`,
    SEEN_ALL: (type: string) => `/api/notification-service/notifications/seen-all?type=${type}`,
    DEVICE: "/api/notification-service/notifications/device",
  },
  AFFILIATE: {
    OVERVIEW: "/api/affiliate-service/overview",
    REQUEST_AFFILIATE: "/api/affiliate-service/request-affiliate",
    REFERRAL_HISTORY: "/api/affiliate-service/referral-history",
    REFERRAL_LIST: "/api/affiliate-service/referral-list",
  },
} as const;
